import assert from "assert";

export class IFinancialModel {

  // Returns a promise
  createForecast(forecast) {
    assert(false, 'FinancialModel.createForecast function not implimented')
  }

  // Returns a promise
  storeForecast(forecastId, forecast) {
    assert(false, 'FinancialModel.storeForecast function not implimented')
  }

  // Returns a promise
  retrieveForecast() {
    assert(false, 'FinancialModel.retrieveForecast function not implimented')
  }

  // Returns a promise
  removeForecast(forecastId) {
    assert(false, 'FinancialModel.removeForecast function not implimented')
  }

  // Returns a promise
  storeEqValuation(companyId, eqValuation) {
    assert(false, 'FinancialModel.storeEqValuation function not implimented')
  }

  // Returns a promise
  retrieveEqValuation(companyId) {
    assert(false, 'FinancialModel.retrieveEqValuation function not implimented')
  }
  
}
export default IFinancialModel
